import { render, staticRenderFns } from "./renewBot.vue?vue&type=template&id=3b4ee2b5&scoped=true&"
import script from "./renewBot.vue?vue&type=script&lang=js&"
export * from "./renewBot.vue?vue&type=script&lang=js&"
import style0 from "./renewBot.vue?vue&type=style&index=0&id=3b4ee2b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4ee2b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
